import { createSlice } from '@reduxjs/toolkit';

export const languages = [
  { code: 'EN', locale: 'en-US', direction: 'ltr' },
  { code: 'PT', locale: 'pt-BR', direction: 'ltr' },
];
/* TODO remover quando tiver a certeza de que está padronizado em ingles */
// const navigatorLang = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;

const findOrDefault = (key) => {
  return (
    languages.find((x) => x.locale === key || x.code === key) || languages[0]
  );
};

const initialState = {
  languages,
  currentLang: { code: 'EN', locale: 'en-US', direction: 'ltr' },
};

const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    changeLang(state, action) {
      state.currentLang = findOrDefault(action.payload);
    },
  },
});
export const { changeLang } = langSlice.actions;
const langReducer = langSlice.reducer;

export default langReducer;
